var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 99,
    viewBox: "0 0 82 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.83333 20.1665C-7.6868 20.1665 -10 22.4797 -10 25.3332V96.4998C-10 99.3533 -7.6868 101.667 -4.83333 101.667H66.3333C69.1868 101.667 71.5 99.3533 71.5 96.4998V25.3332C71.5 22.4797 69.1868 20.1665 66.3333 20.1665H-4.83333ZM-20 25.3332C-20 16.9569 -13.2097 10.1665 -4.83333 10.1665H66.3333C74.7097 10.1665 81.5 16.9569 81.5 25.3332V96.4998C81.5 104.876 74.7097 111.667 66.3333 111.667H-4.83333C-13.2097 111.667 -20 104.876 -20 96.4998V25.3332Z",
    fill: "#869BC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0835 0C53.8449 0 56.0835 2.23858 56.0835 5V25.3333C56.0835 28.0948 53.8449 30.3333 51.0835 30.3333C48.3221 30.3333 46.0835 28.0948 46.0835 25.3333V5C46.0835 2.23858 48.3221 0 51.0835 0Z",
    fill: "#869BC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4165 0C13.1779 0 15.4165 2.23858 15.4165 5V25.3333C15.4165 28.0948 13.1779 30.3333 10.4165 30.3333C7.65508 30.3333 5.4165 28.0948 5.4165 25.3333V5C5.4165 2.23858 7.65508 0 10.4165 0Z",
    fill: "#869BC9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-20 45.6665C-20 42.9051 -17.7614 40.6665 -15 40.6665H76.5C79.2614 40.6665 81.5 42.9051 81.5 45.6665C81.5 48.4279 79.2614 50.6665 76.5 50.6665H-15C-17.7614 50.6665 -20 48.4279 -20 45.6665Z",
    fill: "#869BC9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.529d4a7535a61409134b1f8ca39d05a2.svg";
export { ForwardRef as ReactComponent };